import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.999 4.375c-2.104 0-3.789.975-5.015 2.136-1.22 1.15-2.034 2.53-2.42 3.475a.86.86 0 0 0 0 .652c.386.947 1.2 2.325 2.42 3.476 1.226 1.16 2.91 2.136 5.015 2.136s3.788-.975 5.015-2.136c1.219-1.154 2.034-2.53 2.422-3.476a.86.86 0 0 0 0-.652c-.388-.946-1.203-2.324-2.422-3.475-1.227-1.16-2.911-2.136-5.015-2.136m3.75 5.938c0 2.107-1.68 3.816-3.75 3.816s-3.75-1.71-3.75-3.816c0-2.108 1.68-3.817 3.75-3.817s3.75 1.71 3.75 3.816m-3.75-1.697c0 .936-.748 1.697-1.667 1.697-.3 0-.58-.08-.823-.223q-.009.11-.01.223c0 1.404 1.12 2.544 2.5 2.544s2.5-1.14 2.5-2.544-1.12-2.545-2.5-2.545q-.11 0-.219.01c.138.247.219.533.219.838"
    }, null, -1)
  ]))]))
}
export default { render: render }